module.exports = __webpack_public_path__ + "static/media/shell_logo.02213411.png";